"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasePlayer = void 0;
var Player_1 = require("./Player");
var LoggerFactory_1 = require("../../factory/LoggerFactory");
var BasePlayer = (function (_super) {
    __extends(BasePlayer, _super);
    function BasePlayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.logger = LoggerFactory_1.LoggerFactory.createLogger();
        return _this;
    }
    BasePlayer.prototype.pause = function () {
        this.logger.log('[PLAYER]: Base Client pause without implementation!');
    };
    BasePlayer.prototype.play = function () {
        this.logger.log('[PLAYER]: Base Client play without implementation!');
    };
    BasePlayer.prototype.stop = function () {
        this.logger.log('[PLAYER]: Base Client stop without implementation!');
    };
    BasePlayer.prototype.mute = function () {
        this.logger.log('[PLAYER]: Base PLAYER mute without implementation!');
    };
    BasePlayer.prototype.fastSeekToPosition = function (position) {
        this.logger.log('[PLAYER]: Base fast seek without implementation');
    };
    BasePlayer.prototype.changePlaybackRate = function (rate) {
        this.logger.log('[PLAYER]: Base PLAYER changePlaybackRate without implementation!');
    };
    BasePlayer.prototype.getCurrentPosition = function () {
        this.logger.log('[PLAYER]: Base Client getCurrentPosition without implementation!');
        return 0;
    };
    BasePlayer.prototype.isPlaying = function () {
        return false;
    };
    BasePlayer.prototype.setVolume = function (volume) {
        console.log('[PLAYER]: Set volume to player ', volume);
    };
    return BasePlayer;
}(Player_1.Player));
exports.BasePlayer = BasePlayer;
//# sourceMappingURL=BasePlayer.js.map